import { createRequest } from './createRequest';
import { parseResponse } from './parseResponse';

export async function getCart(checkoutSessionId) {
  return await fetch(createRequest(`/checkoutApi/checkout_session_id/${checkoutSessionId}/cart`, 'GET')).then(
    parseResponse
  );
}

export async function getMerchantName(checkoutSessionId) {
  return await fetch(createRequest(`/checkoutApi/checkout_session_id/${checkoutSessionId}/trade_name`, 'GET')).then(
    parseResponse
  );
}

export async function getLogotype(checkoutSessionId) {
  return await fetch(createRequest(`/checkoutApi/checkout_session_id/${checkoutSessionId}/logotype`, 'GET')).then(
    parseResponse
  );
}
